import * as s from "ramda";
import { useMemo as e } from "react";
const r = () => {
  const t = typeof window < "u" ? s.pathOr("", ["navigator", "userAgent"], window) : "", o = e(() => s.test(/whatsapp/i, t), [t]), n = e(() => s.test(/Windows/i, t), [t]);
  return {
    userAgent: t,
    isWhatsApp: o,
    isWindowsOS: n
  };
};
export {
  r as default
};
//# sourceMappingURL=useUserAgent.js.map
